import { CurrencyEnum, PriceIntervalEnum } from "@finway-group/shared/lib/models"
import React from "react"
import { PerDiemExpenditureTypeEnum } from "~Components/forms/expenseForm/reimbursementForms/perDiem/components/perDiemOptionRow"
import { PriceLabel } from "~Components/priceLabel"

interface PerDiemOptionCellProps {
    dayIndex: number
    fieldName: PerDiemExpenditureTypeEnum
    isExpenditureActive: boolean
    onChange: (field: string, checked: boolean) => void
    value: number
    icon: JSX.Element
}
const PerDiemOptionCell = ({ dayIndex, fieldName, onChange, isExpenditureActive, value, icon }: PerDiemOptionCellProps) => {
    const shouldShowNumber = fieldName === PerDiemExpenditureTypeEnum.ACCOMMODATION ? !isExpenditureActive : isExpenditureActive
    const isDeducting = fieldName !== PerDiemExpenditureTypeEnum.ACCOMMODATION
    const displayValue = Math.abs(value) * (Number(isDeducting) ? -1 : 1)
    return (
        <>
            <div
                className="flex justify-center h-48"
                onClick={() => onChange(fieldName, !isExpenditureActive)}
                role="button"
                aria-pressed={isExpenditureActive}
                data-testid={`finway:perDiemForm:day-${dayIndex}:${fieldName}-toggle`}
            >
                <div className={`rounded-full flex justify-center w-48 border-2 ${isExpenditureActive ? "border-solid" : "border-transparent"}`}>
                    <span className="self-center w-24 h-24">{icon}</span>
                </div>
            </div>
            <div className="text-center h-16" data-testid={`finway:perDiemForm:day-${dayIndex}:${fieldName}-amount`}>
                {shouldShowNumber && <PriceLabel currency={CurrencyEnum.EUR} value={displayValue} interval={PriceIntervalEnum.ONE_TIME} />}
            </div>
        </>
    )
}

export default React.memo(PerDiemOptionCell)
